import { render, staticRenderFns } from "./NewRoom.vue?vue&type=template&id=08ba3afc&scoped=true&"
import script from "./NewRoom.vue?vue&type=script&lang=js&"
export * from "./NewRoom.vue?vue&type=script&lang=js&"
import style0 from "./NewRoom.vue?vue&type=style&index=0&id=08ba3afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba3afc",
  null
  
)

export default component.exports